module.exports = __webpack_public_path__ + "static/media/night07.502651ac.jpg";